export default {
    schoolId: 6773,
    abbr: 'scvtc'
}